module.exports = __webpack_public_path__ + "img/1-md.c9cbe49d.jpg";